import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { PAGE_NAME_STEPS, AppWizardService } from '../services/app-wizard.service';
import { WizardStep } from '../models/app-wizard-state';

function getStepIndex(url: string) {
	for (const [i, PAGE_NAME_STEP] of PAGE_NAME_STEPS.entries()) {
		if (url.includes(PAGE_NAME_STEP)) {
			return i;
		}
	}
	if (url.includes('template')) {
		return WizardStep.HEADER; // access to template from informations and selection step
	}
	return WizardStep.HEADER;
}

export const wizardEnterGuard: CanActivateFn = async (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const router = inject(Router);
	const appWizardService = inject(AppWizardService);
	const stepIndex = getStepIndex(state.url);
	await appWizardService.checkWizardStateValidity(stepIndex, !state.url.includes('template'));
	const isOfferTypeExists = appWizardService.checkOfferTypeExists();
	if (!isOfferTypeExists) {
		await router.navigateByUrl('home', { replaceUrl: true });
		return false;
	}
	return true;
};
